
export const Solutions = () => {

    return (
        <>
            <section>
                <div>
                    <h2 className="text-4xl mt-4" >Value Search 🔎</h2>
                    <p>
                        Shows properties with similar value in other locations, combining current and historical purchase prices to show the ROI for a property.
                    </p>
                    <p>
                        Combined with calculator tools, you will be equipped to have an accurate picture of the investment costs for a given property.
                    </p>
                </div>
                <div>
                    <h2 className="text-4xl mt-4">London Property Analytics 📈</h2>
                    <p>Shows current market trends</p>
                    <p>Quickly see which areas are more profitable to invest in</p>
                </div>
            </section>
        </>
    )
}